import { useCallback, useState } from 'react';

import { isMediaTypeConflict } from '../media/storyMediaItem';

function useStoryMediaTypeConflict({ selectedItems }) {
  const [conflict, setConflict] = useState(null);

  const requestAction = useCallback(
    (incomingType, onConfirm) => {
      if (isMediaTypeConflict(selectedItems, incomingType)) {
        setConflict({ incomingType, onConfirm });
        return false;
      }

      onConfirm();
      return true;
    },
    [selectedItems],
  );

  const confirm = useCallback(() => {
    conflict?.onConfirm();
    setConflict(null);
  }, [conflict]);

  const cancel = useCallback(() => {
    setConflict(null);
  }, []);

  return {
    isOpen: Boolean(conflict),
    incomingType: conflict?.incomingType ?? null,
    requestAction,
    confirm,
    cancel,
  };
}

export default useStoryMediaTypeConflict;
